(() => {
  const ROOT = '.ct-tabs[data-section-id]';
  const PANELS = '[data-ct-tabs-panels]';
  const RADIO = '.ct-tab__radio';

  const isDesignMode = () => !!(window.Shopify && Shopify.designMode);

  function getSectionWrapper(el) {
    return el.closest('.shopify-section') || el;
  }

  function getNextSectionWrapper(wrapper) {
    let n = wrapper.nextElementSibling;
    while (n) {
      const tag = (n.tagName || '').toLowerCase();
      if (tag === 'script' || tag === 'style' || tag === 'template') {
        n = n.nextElementSibling;
        continue;
      }
      if (n.classList && n.classList.contains('shopify-section')) return n;
      if (n.hasAttribute && n.hasAttribute('data-shopify-section-id')) return n;
      n = n.nextElementSibling;
    }
    return null;
  }

  function setActivePanel(root, index) {
    const panels = root.querySelectorAll('.ct-tabs__panel');
    panels.forEach((p, i) => {
      const active = i === index;
      p.hidden = !active;
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }

  function ensurePanels(root, num) {
    const host = root.querySelector(PANELS);
    if (!host) return null;

    host.innerHTML = '';
    const panels = [];
    for (let i = 0; i < num; i++) {
      const panel = document.createElement('div');
      panel.className = 'ct-tabs__panel';
      panel.hidden = true;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-hidden', 'true');
      host.appendChild(panel);
      panels.push(panel);
    }
    return panels;
  }

  function bindRadios(root, isSafe) {
    if (root._ctTabsBound) return;
    root._ctTabsBound = true;

    const radios = root.querySelectorAll(RADIO);
    radios.forEach((r, idx) => {
      r.addEventListener('change', () => {
        if (!r.checked) return;
        setActivePanel(root, idx);

        // 前台可选 hash，同步 tab
        if (!isSafe) {
          try {
            const url = new URL(window.location.href);
            url.hash = `cttab=${idx + 1}`;
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
      });
    });
  }

  function initOne(root) {
    if (!root || root.dataset.ctTabsInited === '1') return;

    const wrap = getSectionWrapper(root);
    const num = Math.max(1, parseInt(root.dataset.numSections || '1', 10));
    const defaultTab = parseInt(root.dataset.defaultTab || '1', 10);

    const panels = ensurePanels(root, num);
    if (!wrap || !panels) return;

    let next = getNextSectionWrapper(wrap);
    const sources = [];

    for (let i = 0; i < num; i++) {
      if (!next) break;

      const current = next;
      next = getNextSectionWrapper(current);

      // ✅ 只处理 wrapper 内部内容，不动 wrapper 本身
      // 前台：move 内容
      // Editor：clone 内容
      const nodes = Array.from(current.childNodes);

      if (nodes.length === 0) {
        current.style.display = 'none';
        sources.push(current);
        continue;
      }

      if (isDesignMode()) {
        // ✅ Editor 安全：clone，不搬 DOM（不会触发 Broken HTML）
        nodes.forEach((node) => {
          // 仅克隆 element / text / comment 都可以 cloneNode(true)
          panels[i].appendChild(node.cloneNode(true));
        });

        // 为了不重复显示：隐藏原 section wrapper（结构仍然在，不会破坏 editor 树）
        current.style.display = 'none';
      } else {
        // ✅ 前台：move（真正 tabs）
        nodes.forEach((node) => {
          panels[i].appendChild(node);
        });
        current.style.display = 'none';
        current.setAttribute('data-ct-tabs-moved', '1');
      }

      sources.push(current);
    }

    root._ctTabsSources = sources;

    bindRadios(root, isDesignMode());

    // 默认选中（支持 hash）
    const radios = root.querySelectorAll(RADIO);
    let activeIndex = Math.min(Math.max(defaultTab - 1, 0), panels.length - 1);

    const m = window.location.hash.match(/cttab=(\d+)/);
    if (m) {
      const fromHash = parseInt(m[1], 10);
      if (!Number.isNaN(fromHash)) {
        activeIndex = Math.min(Math.max(fromHash - 1, 0), panels.length - 1);
        if (radios[activeIndex]) radios[activeIndex].checked = true;
      }
    }

    // 如果没任何 checked，就强制第一个
    if (radios.length && !Array.from(radios).some(r => r.checked)) {
      radios[activeIndex]?.setAttribute('checked', 'checked');
      radios[activeIndex].checked = true;
    }

    setActivePanel(root, activeIndex);

    root.dataset.ctTabsInited = '1';
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT).forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  // Editor 热加载/重载
  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector(ROOT);
    if (root) {
      root.dataset.ctTabsInited = '0';
      root._ctTabsBound = false;
      root._ctTabsSources = null;
    }
  });
})();